let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c2Pg5")).then(() => parcelRequire('G5VDb'));